/* ==============================================================
   TTW CUSTOM JS - The Topi Wala
   Banaya: 2 August 2026

   Ye scripts pehle layout/theme.liquid ke andar inline pade the,
   isi liye har theme update par gayab ho jate the. Ab alag file
   mein hain - theme update par sirf copy karni hai.

   Load: snippets/ttw-custom.liquid se, defer ke saath.
   ============================================================== */
(function () {
  'use strict';

  /* -- 1. LOGO WORDMARK: "THE TOPI WALA" mein TOPI ko crimson karo --
     Theme sirf shop.name ka plain text daalta hai, isliye ek hi lafz
     ka rang CSS se nahi badla ja sakta. Yahan us text ko teen hisson
     mein tor kar beech wale ko span mein lapet dete hain. */
  function brandLogo() {
    var nodes = document.querySelectorAll('.logotext');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.dataset.ttwDone) continue;
      var words = (el.textContent || '').trim().split(/\s+/);
      if (words.length < 2) continue;

      var html = '';
      for (var w = 0; w < words.length; w++) {
        if (words[w].toLowerCase() === 'topi') {
          html += '<span class="ttw-logo-accent">' + words[w] + '</span>';
        } else {
          html += words[w];
        }
        if (w < words.length - 1) html += ' ';
      }
      el.innerHTML = html;
      el.dataset.ttwDone = '1';
    }
  }

  /* -- 2. MARQUEE DEDUPLICATION FIX --
     Theme kabhi kabhi marquee ke andar duplicate spans bana deta hai.
     Ye sirf 1 asli + 1 aria-hidden clone rakhta hai. */
  function fixMarquee() {
    var track = document.querySelector('.marquee');
    if (!track) return;
    var spans = Array.prototype.slice.call(
      track.querySelectorAll(':scope > .marquee-content')
    );
    if (spans.length <= 2) return;
    for (var i = 1; i < spans.length; i++) spans[i].remove();
    var clone = spans[0].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }

  /* -- 3. PRODUCT PAGE: page upar se shuru ho --
     PURANA TAREEQA: setInterval har 50ms, 15 baar - user scroll kare
     to page wapas upar khinch jata tha, aur INP score kharab hota tha.
     NAYA: browser ko keh do scroll khud restore na kare. Ek hi baar. */
  function pinProductTop() {
    if (!document.body.classList.contains('template-product')) return;
    if (location.hash) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }

  function init() {
    try { brandLogo(); } catch (e) {}
    try { fixMarquee(); } catch (e) {}
    try { pinProductTop(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
